import { call, put, select, takeLatest } from 'redux-saga/effects';
import { setError, getTariffSuccess, setSalesChannel } from './action';
import { ActionType } from './enum';
import { selectSalesChannel, selectSelectedOption, selectTariffs } from './selector';
import { getPathData } from '../../helper/urlHelper';
import { SalesChannel } from '../../enum';
import { showLoadingSpinner } from '../../components/loadingSpinner';
import { getTariff } from 'Helper/apiHelper';
import { trackPageView } from './helpers/tracking';
import { SelectedOption } from './interface';
import { getHashcode, validateHashcode } from 'Helper/fnfHelper';
import { setCookie } from '@vfde-fe/utils';
import { FNF_ERROR_PAGE_URL, FNF_COOKIE_NAME } from 'Constant';
import { ApiErrorResponseWithCode } from '@vfde-fe/sails_core';
import Data from '../../interface/dto/Data';

export function* validateFFSaga () {
    const hashcode = getHashcode();

    if (!hashcode) {
        return;
    }

    try {
        const response = yield call(validateHashcode, hashcode);
        switch (response.body.status) {
            case 'valid':
                setCookie(FNF_COOKIE_NAME, { value: hashcode });
                yield put(setSalesChannel(SalesChannel.FF));
                break;
            default:
                throw new Error('invalid ffgc token');
        }
    } catch (error) {
        if (error instanceof ApiErrorResponseWithCode) {
            yield put(setError(error));
        } else {
            window.location.assign(FNF_ERROR_PAGE_URL);
        }
    }
}

/**
 * Feth the Tariff object from the API
 *
 * Tariff object can contain multiple Hardware object,
 * but the sales channel discount are not strict to their sales channel
 * so we need to fetch sales channels in separate calls
 */
export function* getTariffsSaga () {
    const salesChannel: SalesChannel = yield select(selectSalesChannel);
    const tariffs: Data = yield select(selectTariffs);
    if (tariffs?.tariffs) {
        return;
    }

    try {
        showLoadingSpinner();

        const response = yield call(getTariff, salesChannel);

        yield put(getTariffSuccess(response.body));
    } catch (error) {
        yield put(setError(error));
    } finally {
        showLoadingSpinner(false);
    }
}

/**
 * After a change in selectedOption or in salesChannel
 * this function handles navigation between flex and consumer pages
 * setting the page URL with queries and firing tracking
 */
export function* handleSelectOptionSaga () {
    const sales: SalesChannel = yield select(selectSalesChannel);
    const selected: SelectedOption = yield select(selectSelectedOption);

    const pathData = getPathData(selected?.subscriptionId, selected?.hardwareId, sales);

    if (pathData && pathData.force) {
        location.assign(pathData.path);
    } else if (pathData) {
        window.history.replaceState(null, '', pathData.path);

        trackPageView(selected, sales);
    }
}

export function* trackPageViewSaga () {
    const sales: SalesChannel = yield select(selectSalesChannel);
    const selected: SelectedOption = yield select(selectSelectedOption);

    trackPageView(selected, sales);
}

export function* initStoreSaga () {
    yield validateFFSaga();
    yield getTariffsSaga();
    yield trackPageViewSaga();
}

export default function* appSaga() {
    yield takeLatest(ActionType.INIT_STORE, initStoreSaga);
    yield takeLatest(ActionType.SELECT_OPTION, handleSelectOptionSaga);
    yield takeLatest(ActionType.SET_SALESCHANNEL, handleSelectOptionSaga);
}

